import classNames from "classnames";

type IProps = {
  label?: string;
  className?: string;
};

// Hard-stop message: the option never gets an inputValue, so the step can't be submitted
const ErrorInnerBlock = ({ label, className }: IProps) => (
  <p role="alert" className={classNames("text-sm sm:text-base", className)}>
    {label}
  </p>
);

export { ErrorInnerBlock };
